module.exports = __webpack_public_path__ + "static/media/anim.a9f60466.svg";